import portalModules from './modules.portal';
import moappModules from './modules.moapp';
import { loadScript, getBaseURLWithDailyRefresh } from '../loader';

const loadModules = (configName, baseURL) => {
    let modules;
    switch (configName) {
        case 'MOApp':
            modules = moappModules;
            break;
        default:
            modules = portalModules;
            break;
    }
    modules.forEach((m) => {
        if (m.preLoad) {
            m.preLoad();
        }
        loadScript({
            id: m.id,
            url: getBaseURLWithDailyRefresh(baseURL) + m.url,
            callback: m.callback ?? null
        });
    });
};

export { loadModules };
